import { moduleNames } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import tradingFloorService from "@services/floorStaff/tradingFloorService"
import { action, makeAutoObservable, observable } from "mobx"

class TradingFloorStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listEmployee!: any[]
  @observable listAgencyMaster!: any[]
  @observable userExistsByPhone!: any
  @observable tabCartTableData!: PagedResultDto<any>
  @observable tabStaffTableData!: PagedResultDto<any>
  /** Nhân viên sàn từ GetUserByAgencyId — dùng cho UI gán vào nhóm (không dùng chung tab staff). */
  @observable groupAssignStaffTableData!: PagedResultDto<any>
  @observable groupAssignStaffLoading!: boolean
  @observable auditLogData!: any
  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.tabCartTableData = { items: [], totalCount: 0 }
    this.tabStaffTableData = { items: [], totalCount: 0 }
    this.groupAssignStaffTableData = { items: [], totalCount: 0 }
    this.groupAssignStaffLoading = false
    this.userExistsByPhone = { id: 0, uniqueId: null, isActive: true }
    this.detailData = {}
    this.listEmployee = []
    this.listAgencyMaster = []
    this.auditLogData = {}
  }

  @action
  async init() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async initUser() {
    this.isLoading = true
    this.userExistsByPhone = { id: 0, uniqueId: null, isActive: true }
    this.isLoading = false
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await tradingFloorService.activateOrDeactivate(id, isActive)
  }

  @action
  async deleteStaffOnCurrentFloor(body: any) {
    await tradingFloorService.deleteStaffOnCurrentFloor(body)
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await tradingFloorService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async get(id: number) {
    const result = await tradingFloorService.get(id)
    this.detailData = result
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    if (!body.id) {
      const result = await tradingFloorService.create(body)
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService.upload(
              moduleNames.TRADINGFLOOR,
              uniqueId,
              fileUpload
            )
          }
        })
        this.isLoading = false
      }
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      const result = await tradingFloorService.update(body)
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async getListEmployee() {
    this.isLoading = true
    this.listEmployee = await tradingFloorService
      .getListEmployee()
      .finally(() => (this.isLoading = false))
  }

  @action
  async getAllCartByAgency(params: any) {
    this.isLoading = true
    this.tabCartTableData = await tradingFloorService
      .getAllCartByAgency(params)
      .finally(() => (this.isLoading = false))
  }

  @action
  async getAllStaffInCurrentTradingFloor(params: any) {
    this.isLoading = true
    this.tabStaffTableData = await tradingFloorService
      .getAllStaffInCurrentTradingFloor(params)
      .finally(() => (this.isLoading = false))
  }

  /** Danh sách nhân viên theo đại lý (GetUserByAgencyId) cho modal gán nhóm — không làm Loading chung của sàn. */
  @action
  async loadStaffForGroupAssignPicker(params: {
    agencyMasterId: number
    skipCount: number
    maxResultCount: number
    keyword?: string
    isActive?: boolean
  }) {
    this.groupAssignStaffLoading = true
    this.groupAssignStaffTableData = await tradingFloorService
      .getAllStaffInCurrentTradingFloor(params)
      .finally(() => {
        this.groupAssignStaffLoading = false
      })
  }

  @action
  async getExistPhone(phone: string) {
    const result = await tradingFloorService.getExistPhone(phone)
    this.userExistsByPhone = result
  }

  @action
  async getListAgencyMaster() {
    this.isLoading = true
    const result = await tradingFloorService
      .getListAgencyMaster()
      .finally(() => (this.isLoading = false))
    this.listAgencyMaster = result
    return result
  }

  @action
  async assignUser(body: any) {
    this.isLoading = true
    await tradingFloorService
      .assignUser(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async GetAgencyMasterOutputWithTaxCode(params: any) {
    this.isLoading = true
    const result = await tradingFloorService
      .GetAgencyMasterOutputWithTaxCode(params)
      .finally(() => (this.isLoading = false))
    return result
  }

  @action
  async getAuditLog(id: number) {
    const result = await tradingFloorService.getAuditLog(id)
    this.auditLogData = result
  }
}

export default TradingFloorStore
